<template>
    <div>
        <Mainlayout />
        <HeroSection/>
        <Features />
        <Categories />
        <!-- <GradeList /> -->
        <Events />
        <Testimonials />
        <Footer />
        <div
      v-if="showPopup"
      class="popup-overlay"
    >
      <div class="popup-modal" :style="{ backgroundImage: `url(${require('@/assets/img/bgpatt.png')})` }">
        <button class="close-button" @click="showPopup = false">×</button>
        <img src="@/assets/img/logoround.png" class="popup-logo" />
        <h2 class="popup-title font-Inter">Tonton Dahulu Sebelum Buat Keputusan</h2>
      
        <p class="popup-desc">
            Terokai subjek, kenali guru, dan alami sendiri kualiti FlyHigh serta tonton video percuma daripada tutor terbaik kami!
        </p>
      
        <div class="bg-popup">
        <div class="popup-highlight font-Inter">SEGALA BERMULA DISINI</div>
      </div>
      <div class="join-wrapper">
            <img src="../assets/img/light1.png" class="light-img" />
            <div class="button-wrapper">
                <a
            href="https://wa.me/601135546900?text=Saya%20ingin%20tanya%20berkaitan%20kelas%20di%20FlyHigh"
            target="_blank"
            rel="noopener noreferrer"
            >
                <button class="join-button">Join Us</button>
                </a>
            </div>
            <img src="../assets/img/ligh2.png" class="light-img" />
            </div>
      </div>
    </div>
       

    
    
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

  import _ from "lodash";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


import Header from '@/components/Header.vue'
import HeroSection from '@/components/HeroSection.vue'
// import GradeList from '@/components/GradeList.vue'   
import Features from '@/components/Features.vue'
import Categories from '@/components/Categories.vue'
import Events from '@/components/Events.vue'
import FeaturedLearning from '@/components/FeatureLearningMaterial.vue'
import FeaturedCourses from '@/components/FeaturedCourse.vue'
import Testimonials from '@/components/Testimonial.vue'
import CTASection from '@/components/CTASection.vue'
import Footer from '@/components/Footer.vue'


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard,
        Header,
        HeroSection,
        // GradeList,
        FeaturedLearning,
        Features,
        Categories,
        Events,
        FeaturedCourses,
        Testimonials,
        CTASection,
        Footer


    },
  
    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,

            name: "",
            email: "",
            phone: "",
            password: "",
            selectedUser: "",


            isLanguagePopupVisible: false,
            emailinterest: "",

            selectedExpertise: "",
            selectedField: "",
            //selectedPosition: "",
            expertiseOptions: [], // Initialize as an empty array
            fieldOptions: [], // Initialize as an empty array
            positionOptions: [],
            isLanguagePopupVisible1: false,
            isLanguagePopupVisible2: false,

            Names: "",
            activetab: "",
            isLoved: false, // Initial state
            filter: false,
            hideColumn: true,
            currentSlide: 0,
      slides: [
        {
          image: require("@/assets/img/step1-htu.png"),
          title: "Initial Setup",
          description: "After login/signup, click the start button at the landing page."
        },
        {
          image: require("@/assets/img/step2-htu.png"),
          title: "Career Path Selection",
          description: "Choose your expertise and submit to begin, select current and career field."
        },
        {
          image: require("@/assets/img/step3-htu.png"),
          title: "Upload Documents",
          description: "Upload any documents, including resume."
        },
        {
          image: require("@/assets/img/step4-htu.png"),
          title: "Start Record",
          description: "Start the answer interview by clicking the Red button for an interview to start."
        },
        {
          image: require("@/assets/img/step5-htu.png"),
          title: "Share",
          description: "Once completed, click the share button to copy the link and send it to your potential employee."
        }
      ],

            isCategoryListVisible: true, // Toggle state
            isTypeListVisible: false,
            isCategorySeniorityVisible: false,
            categoryJob: [],
            categoryJobType: [],
            categoryJobSeniority: [],
            isLoved: false, // Initial state
            progressBarValue: 50, // Initial value (percentage)
      minSalary: 50000,    // Example minimum salary
      maxSalary: 100000,   // Example maximum salary
      companyCode: false,
      codeCompany: '',
      ErrorCode: false,
      ShowCode: false,
      Message: "",
      result: {},
      selectedPosition: '',
      ErrorPosition: false,
      user: null,
      Names: "",
      showPopup: false,
        };
        
    },
    created() {
        AOS.init();
    
    },

    mounted() {
        
        this.getListField();
        this.getListExpertise();
        this.getListPosition();
        this.GetListCategoryJob();
        this.GetListCategoryJobType();
        this.GetListCategoryJobSeniority();
        setTimeout(this.TrackDailyVisit, 500);
        setTimeout(() => {
      this.showPopup = true;
    }, 1000); 
        
    },
    computed: {
        popupClass() {
            return this.activetab === 'Career' ? 'popup-all1' : 'popup-all2';
        },
        progressBarWidth() {
      return `${this.progressBarValue}%`; // Convert value to percentage for width
    },
    },
    methods: {
        nextSlide() {
        if (this.currentSlide < this.slides.length - 1) {
            this.currentSlide++;
        } else {
            this.currentSlide = 0; // Loop back to first slide
        }
    },
    prevSlide() {
        if (this.currentSlide > 0) {
            this.currentSlide--;
        } else {
            this.currentSlide = this.slides.length - 1; // Loop to last slide
        }
    },
        changeSlide(index) {
      this.currentSlide = index;
    },
        onCheckboxChange(event) {
        console.log('Checkbox changed:', event.target.checked);
    },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("Index");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("Index");
                console.error("Error fetching user info:", error);
            }
        },
       
        OpenFilter() {
           // this.filter = true;
           // this.hideColumn = false;

            this.filter = !this.filter;
            this.hideColumn = !this.hideColumn;
        
        },
        setActiveTab(tabName) {
            this.activetab = tabName;
        },

       
        toggle() {
            this.isActive = !this.isActive;
        },
        GotoHowItWork() {
            //  this.$router.push("HowItWork");
            this.isLanguagePopupVisible1 = true;
        },
        OpenHowItWork() {
            this.$router.push("HowItWork");
        },
        GoToLogin() {
            this.$router.push("Login");
        },
        closePopup() {
            this.isLanguagePopupVisible1 = false;
        },
        closePopup1() {
            this.isLanguagePopupVisible1 = false;
        },
        closePopup2() {
            this.isLanguagePopupVisible1 = false;
            this.isLanguagePopupVisible2 = false;
        },
        OpenPopup() {
            this.isLanguagePopupVisible = false;
            this.isLanguagePopupVisible1 = true;

        },
        SubmitData() {
            const formData = new FormData();

            formData.append("email", this.emailinterest);
            formData.append("experties", this.selectedExpertise.Name);
            formData.append("field", this.selectedField.Name);


            this.$API
                .post(this.$RegisterInterest, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {

                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {

                                this.isLanguagePopupVisible1 = false;
                                this.isLanguagePopupVisible2 = true;

                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }

                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        OpenFormVideo() {
            if (!this.selectedPosition || !this.selectedPosition.Name) 
            {
                this.Message = 'Please select your current field';
                    this.ErrorPosition = true;
            }
            else
            {
                if(this.ErrorCode === true){
                    this.ErrorPosition = false;
                    this.$router.push("FormVideo" + "?expertise=" + this.selectedPosition.Name + "&field=" + this.selectedPosition.Name + "&position=" + this.selectedPosition.Name)
                }
                else
                {
                    if(this.codeCompany === '')
                    {
                        this.$router.push("FormVideo" + "?expertise=" + this.selectedPosition.Name + "&field=" + this.selectedPosition.Name + "&position=" + this.selectedPosition.Name)

                    }
                    else
                    {
                        this.$router.push("FormVideo" + "?expertise=" + this.selectedPosition.Name + "&field=" + this.selectedPosition.Name + "&position=" + this.selectedPosition.Name + "&code=" + this.codeCompany)
                    }
                   
                }
               
           
            }
        },
        async getListField() {
            try {
                const response = await this.$API.get(this.$GetListField);
                if (response.status === 200) {
                    this.fieldOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getListExpertise() {
            try {
                const response = await this.$API.get(this.$GetListExpertise);
                if (response.status === 200) {
                    this.expertiseOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getListPosition() {
            try {
                const response = await this.$API.get(this.$GetListPosition);
                if (response.status === 200) {
                    this.positionOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        OpenCalendly() {
            window.open("https://calendly.com/rasid-interviewrr");
        },
        toggleLove() {
            this.isLoved = !this.isLoved;
        },
        async GetListCategoryJob() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJob);
                if (response.status === 200) {
                    this.categoryJob = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleCategoryList() {
            this.isCategoryListVisible = !this.isCategoryListVisible;
        },

        async GetListCategoryJobType() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJobType);
                if (response.status === 200) {
                    this.categoryJobType = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleTypeList() {
            this.isTypeListVisible = !this.isTypeListVisible;
        },

        async GetListCategoryJobSeniority() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJobSeniority);
                if (response.status === 200) {
                    this.categoryJobSeniority = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleSeniorityList() {
            this.isCategorySeniorityVisible = !this.isCategorySeniorityVisible;
        },
        async VerifyCodeData() {
        try {
            this.ErrorPosition = false;
            const codeCompany1 = this.codeCompany;
            const response = await this.$API.get(this.$VerifyCode + '?code=' + codeCompany1); // Assuming this.$VerifyCode is your API endpoint URL
            
            if (response.status === 200) {
                this.result = response.data;
                if (this.result === 'The code is not ready for used.') {
                    this.Message = 'The code is not ready for used.';
                    this.ErrorCode = true;
                    
                } else if (this.result === 'The code is expired.') {
                    this.Message = 'The code is expired.';
                    this.ErrorCode = true;
                } else if (this.result === 'The code is invalid.') {
                    this.Message = 'The code is invalid.';
                    this.ErrorCode = true;
                } else {
                    this.Message = response.data
                    this.ShowCode = true;
                    this.ErrorCode = false;
                 
            }
            } else {
                // Handle non-200 status code
                console.error('Failed to fetch data:', response.statusText);
            }
        } catch (error) {
            // Handle the error here
            console.error('Error fetching data:', error);
        }
    },
    GoToVideo()
    {
        this.$router.push("VideoPlaylist");
    },
    TrackDailyVisit() {
    // Fetch the user's IP address using an external API (e.g., ipify)
    fetch('https://ipinfo.io/json')
        .then(response => response.json())
        .then(data => {
            const userIp = data.ip; // Get the IP address

            // Create FormData object
            const formData = new FormData();

            // Add visit data to the form
            formData.append("Count", 1); // Increment by 1 for each visit
            formData.append("IpAddress", userIp); // Add user's IP address

            // API call to update the visit counter
            this.$API
                .post(this.$InsertCounterWebsite, formData)
                .then((response) => {
                    if (response.status === 200) {
                        console.log("Visit recorded successfully");
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        console.error("Error tracking visit:", error.response.status);
                        this.Error = true;
                        this.Message = "Error tracking visit";
                    }
                });
        })
        .catch((error) => {
            console.error("Error fetching IP address:", error);
        });
},
   





    },

};
</script>

<style scoped>

.image-container {
    position: relative;
    max-width: 100%;
}

.background-image {
    width: 100%;
    height: auto;
}

.overlay-text {
    position: absolute;
    bottom: 20px;
    /* Adjust as needed */
    left: 20px;
    /* Adjust as needed */
    right: 20px;
    /* Adjust as needed */
    background-color: rgba(0, 0, 0, 0.5);
    /* Semi-transparent background */
    color: white;
    padding: 10px;
    text-align: center;
    font-size: 1.2em;
    /* Adjust as needed */
    width: 70%;
    margin: 0 auto;
}

pre {
    white-space: pre-wrap;
    /* Ensures that newlines and spaces are rendered as expected */
    color: #171717;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 27px */
}

.bottom-right-button {
    position: absolute;
    bottom: 20px;
    /* Adjust as needed */
    right: 80px;
    /* Adjust as needed */
    padding: 10px 20px;
    background-color: #007bff;
    /* Button color */
    color: white;
    border: none;
    border-radius: 20px;
    cursor: pointer;
}

.bottom-right-button-text {
    position: absolute;
    bottom: 90px;
    /* Adjust as needed */
    right: 20px;
    /* Adjust as needed */
    padding: 10px 20px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    color: #000;
    font-weight: 600;
}

.bottom-right-button:hover {
    background-color: #0056b3;
    /* Hover color */
}

/* .popup-all1 {
    width: 500px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    z-index: 1000;
    margin: 0 auto;
    margin-top: 2%;
    height:70vh;
} */

.popup-all2 {
    width: 900px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    z-index: 1000;
    margin: 0 auto;
    margin-top: 4%;
    z-index: 1;
    height:90vh;
}
.salary-range {
  padding: 20px;
}

.progress {
  height: 20px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: #007bff;
}

.custom-range {
  width: 100%;
}

.input-container {
  position: relative;
  display: inline-block;
  width:100%;
}

input[type="text"].custom {
  padding-right: 60px; /* Adjust according to button width */
  height:80px;
}

.verify-button {
  position: absolute;
  right: 2px;
  top: 3px;
  bottom:3px;
  height: 28px;
  border-radius: 50px;
  background: #928AFD;
  color:#fff;
  /* Optional: Adjust the button height to match the input field */
}
.disabled {
    cursor: not-allowed;
    opacity: 0.5;
}
.slider-container {
  text-align: center;
  /* padding: 30px 20px; */
  background: #fff;
  max-width: 500px; /* Adjust as needed */
  margin: auto;
    overflow: hidden;
    position: relative;
    width: 100%;
}

/* Title */
.title {
  font-size: 28px;
  font-weight: bold;
}

/* Wrapper */
.slider-wrapper {
  overflow: hidden;
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
}

/* Slider track */
.slider {
  display: flex;
  transition: transform 0.5s ease-in-out;
}

/* Individual slide */
.slide {
  min-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

/* Card style */
.card-slider {
  max-width: 500px;
  background: linear-gradient(135deg, #e0e0e0, #ffffff);
  border-radius: 12px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  text-align: left;
  transition: transform 0.3s ease;
}

.card-slider:hover {
  transform: scale(1.02);
}

/* Image */
.card-img {
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

/* Card content */
.card-content {
  padding-top: 10px;
  padding:10px;
}

/* Step number */
.step-number {
  background: #6C5CE7;
  color: #fff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  margin-right: 8px;
}

/* Step title */
.step-title {
  font-size: 18px;
  font-weight: bold;
}

/* Step description */
.step-description {
  font-size: 14px;
  color: #555;
}

/* Pagination */
.pagination {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}

.pagination span {
  width: 12px;
  height: 12px;
  background: #d3d3d3;
  margin: 5px;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.3s ease;
}

.pagination span.active {
  background: #6C5CE7;
  transform: scale(1.2);
}

.prev, .next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    color: white;
    border: none;
    padding: 15px;
    cursor: pointer;
    font-size: 24px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Ensure buttons are visible */
.prev {
    left: 10px; /* Adjust as needed */
}

.next {
    right: 10px; /* Adjust as needed */
}

/* Optional: Hover effect */
.prev:hover, .next:hover {
    background: rgba(0, 0, 0, 0.8);
}
</style>